module.exports = __webpack_public_path__ + "static/media/efiling-picturemark-d.e1f57cb1.svg";